// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyCloneWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyCloneRequestWebDto, UserPropertyCloneResponseWebDto } from '../..';

export const RentalManagerUserPropertyCloneWebApiHandler_clone_Path = '/api/web/v1/users/properties/clone';

/**
 * Clone a property
 */
export const RentalManagerUserPropertyCloneWebApiHandler_clone = (
  postData: UserPropertyCloneRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyCloneRequestWebDto, UserPropertyCloneResponseWebDto>(
    {
      endpoint: RentalManagerUserPropertyCloneWebApiHandler_clone_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
